import * as React from 'react'

function SvgAccessibleRounded(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2a2 2 0 100 4 2 2 0 000-4zm7 9.9c0-.49-.36-.89-.84-.97a5.762 5.762 0 01-3.23-1.76l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.005 0-.007-.003-.01-.005-.002-.003-.005-.005-.01-.005H13c-.37-.21-.78-.31-1.25-.25C10.73 7.15 10 8.07 10 9.1V15c0 1.1.9 2 2 2h5v4c0 .55.45 1 1 1s1-.45 1-1v-4.5c0-1.1-.9-2-2-2h-3v-3.45c1 .83 2.4 1.54 3.8 1.82.62.13 1.2-.34 1.2-.97zM10 20c1.31 0 2.42-.84 2.83-2h2.07A5 5 0 119 12.1v2.07c-1.16.42-2 1.52-2 2.83 0 1.66 1.34 3 3 3z"
        fill="currentColor"
      />
    </svg>
  )
}

export default SvgAccessibleRounded
